module.exports = __webpack_public_path__ + "static/media/29150005-min.af8f581d.jpg";